<template>
  <div class="location">
    <img class="location-image" v-bind:src="currentItem.image" />
    <p class="location-title">{{ currentItem.name }}</p>
    <p class="location-text">{{ currentItem.description }}</p>
  </div>
</template>

<script>
import axios from 'axios'
import Header from './Header.vue'

export default {
  name: 'Finnaqee',
  props: ['locationId', 'locationObj'],
  components: {
    Header
  },
  watch: {
    '$route': 'fetchData'
  },

  data () {
    this.fetchData()

    return {
      currentItem: 'ASDF',
      x: this.locationId,
      y: this.locationObj
    }
  },

  methods: {
    fetchData () {
      axios.get('http://cms.finnaqee.de/get_all_locations/')
        .then(response => {
          this.results = response.data.msg.data

          for (let idx in this.results) {
            if (parseInt(idx) === (parseInt(this.locationId) - 1)) {
              this.currentItem = this.results[idx]
            }
          }
          window.scrollTo(0, 0)
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .location {
    height: calc(100vh - 64px);
    background-color: white;
  }

  .location-image {
    width: 100%;
  }

  .location-title {
    text-align: left;
    padding-top: 10px;
    padding-left: 10px;
    padding-right: 10px;
    color: #888;
    font-size: larger;
  }

  .location-text {
    text-align: left;
    padding-left: 10px;
    padding-right: 10px;
    font-size: small;
    color: #888;
  }

</style>



// WEBPACK FOOTER //
// src/components/Details.vue